import React from "react";

const FaqSkeleton = () => {
  return (
    <div className="faq-list">
      {[1, 2, 3, 4, 5].map((item) => (
        <div className="faq-card shimmer" key={item}>
          <div
            style={{
              height: "24px",
              width: "80%",
              margin: "18px 16px",
              borderRadius: "8px",
            }}
            className="skeleton-box"
          ></div>

          <div
            style={{
              height: "16px",
              width: "92%",
              margin: "0 16px 12px",
              borderRadius: "6px",
            }}
            className="skeleton-box"
          ></div>

          <div
            style={{
              height: "16px",
              width: "70%",
              margin: "0 16px 18px",
              borderRadius: "6px",
            }}
            className="skeleton-box"
          ></div>
        </div>
      ))}
    </div>
  );
};

export default FaqSkeleton;